const getEnv = (key: string, fallback = ''): string => {
  try {
    return (import.meta as any)?.env?.[key] ?? fallback;
  } catch {
    return fallback;
  }
};

export const ENV = {
  FIREBASE_API_KEY: getEnv('VITE_FIREBASE_API_KEY', 'AIzaSyBtYKRD5dps3Ltaxuz-i5i2p_u07HMOeKQ'),
  FIREBASE_AUTH_DOMAIN: getEnv('VITE_FIREBASE_AUTH_DOMAIN', 'erp-mock.firebaseapp.com'),
  FIREBASE_PROJECT_ID: getEnv('VITE_FIREBASE_PROJECT_ID', 'erp-mock'),
  FIREBASE_STORAGE_BUCKET: getEnv('VITE_FIREBASE_STORAGE_BUCKET', 'erp-mock.firebasestorage.app'),
  FIREBASE_MESSAGING_SENDER_ID: getEnv('VITE_FIREBASE_MESSAGING_SENDER_ID', '622564923574'),
  FIREBASE_APP_ID: getEnv('VITE_FIREBASE_APP_ID', '1:622564923574:web:396ad1f05d1acb0676ee17'),
  FIREBASE_MEASUREMENT_ID: getEnv('VITE_FIREBASE_MEASUREMENT_ID', 'G-VMPFD7YX7X'),
  FIREBASE_FUNCTIONS_URL: getEnv('VITE_FIREBASE_FUNCTIONS_URL'),
  ONESIGNAL_APP_ID: getEnv('VITE_ONESIGNAL_APP_ID'),
  ONESIGNAL_SAFARI_WEB_ID: getEnv('VITE_ONESIGNAL_SAFARI_WEB_ID'),
};